import { decode as base64_decode, encode as base64_encode } from "base-64";
import RootStore from "./RootStore";
import { postApi } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";

class LiveRootPathStore {
  vehicleList = [];
  total = 0;
  loading = false;
  offlineData = [];
  loggingInProgress = true;
  pgcount = 1;
  offset = 0;
  tableDataArray = [];
  offlineLatLongArray = [];
  offlineShowingLatLong = [];
  historyPlottingIndex = 0;
  liveTrackInterval1 = 0;
  vehicleId = "";
  totalCount = null;
  postData = {};
  liveLatLongArray = [];
  polylineArrayObject = {};
  currentIndex = 0;
  vehiclePosition = [];
  checked = true;
  totalRecordCount = 0;
  last_record_timestamp = "";
  offlineDataNewObj = [];
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      total: observable,
      loading: observable,
      offlineData: observable,
      pgcount: observable,
      checked: observable,
      offset: observable,
      offlineLatLongArray: observable,
      offlineShowingLatLong: observable,
      totalCount: observable,
      postData: observable,
      loggingInProgress: observable,
      vehicleId: observable,
      liveLatLongArray: observable,
      polylineArrayObject: observable,
      currentIndex: observable,
      tableDataArray: observable,
      vehiclePosition: observable,
      totalRecordCount: observable,

      addData: action,
      getVehiclePosition: action,
      loadData: action,
      setOfflineData: action,
      handleOfflineData: action,
      loadVehiclePosition: action,
      last_record_timestamp: observable,
      offlineDataNewObj: observable,
    });
    this.rootStore = rootStore;
  }

  async addData({ jTypeName }) {
    var postData = { jobType: { jTypeName: jTypeName } };
    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=delivery&a=addJobtype", "postData=" + base64Input);
    console.log("fuel detis ", response.data.data);
  }

  async loadData({ companyId }) {
    console.log(companyId);
    var postData = { companyId: companyId };
    const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=vehicle&a=getVehicles", "postData=" + base64Input);
    var response = await postApi
      .getClient("NodeCoreUrl")
      .get("vehicle/getVehicles", { params: postData });
    this.vehicleList = response?.data?.vehicleData;
  }

  async setOfflineData(data) {
    this.vehicleId = data.vehicleId;
    this.postData = data;
    var postData = {
      ...data,
      page: this.pgcount,
      offset: this.offset,
      tablename: "pmistrack.fm_mt90",
      interval: "0",
      remaning_vehicleId: "",
      last_record_timestamp: this.last_record_timestamp,
      vehicleId: [data.vehicleId],
      totalCount: this.totalCount ?? 0,
    };
    const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post("index.php?c=vehicle&a=offlinedata", "postData=" + base64Input);
    var response = await postApi
      .getClient("NodeCoreUrl")
      .post("/liveTracking/getHistoryTrackingDataCH", postData);

    let totalCount = response?.data?.data?.totalcount;

    this.offlineData = response?.data?.data;

    // if (response?.data?.data?.last_record_timestamp) {
    //   this.last_record_timestamp = response?.data?.data?.last_record_timestamp;
    // }

    if (this.checked) {
      if (this.totalCount === totalCount) {
        this.loggingInProgress = false;
        // this.getVehiclePosition();
        // let interVal = setInterval(() => {
        //   this.getVehiclePosition();
        // }, 30000);
      }
      if (this.totalCount === null) {
        this.totalRecordCount = response?.data?.data?.totalcount;
        this.totalCount = totalCount;
      }

      if (
        this.totalCount >= 10 ||
        (this.totalCount < 10 && this.totalCount >= 0)
      ) {
        // await this.offlineData.vehicleposition.forEach((val) => {
        //   this.offlineLatLongArray.push(val);
        // });

        // await this.handleOfflineData();
        if (await this.offlineData?.vehicleposition) {
          await this.offlineData?.vehicleposition?.forEach((val) => {
            this.offlineLatLongArray.push(val);
          });
          await this.handleOfflineData();
        }
      } else if (this.totalCount === 0) {
        console.log("end");
      }
    }
    // return response?.data?.data;
  }

  async handleOfflineData() {
    this.totalCount = this.totalCount - 10;
    this.pgcount = ++this.pgcount;
    this.offset = this.offset + 10;
    this.setOfflineData(this.postData);
  }

  async getVehiclePosition() {
    var postData = {
      tokenId: "",
      vehicleId: this.vehicleId,
      userId: 1,
      isadmin: "-1",
      companyId: "1",
      refreshduration: 30,
    };
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post(
    //     "index.php?c=vehicle&a=getvehicleposition",
    //     "postData=" + base64Input
    //   );
    var response = await postApi
      .getClient("NodeCoreUrl")
      .get("liveTracking/getVehiclePositions", {
        params: postData,
      });
    const liveLatLong = response.data.data.vehicleposition[0];

    this.offlineLatLongArray.push([
      liveLatLong.latitude,
      liveLatLong.longitude,
    ]);
  }

  async loadVehiclePosition(vehicleId) {
    var postData = { tokenId: "", vehicleId: vehicleId, refreshduration: 30 };
    // const base64Input = await base64_encode(JSON.stringify(postData));
    // var response = await postApi
    //   .getClient()
    //   .post(
    //     "index.php?c=vehicle&a=getvehicleposition",
    //     "postData=" + base64Input
    //   );
    var response = await postApi
      .getClient("NodeCoreUrl")
      .get("liveTracking/getVehiclePositions", {
        params: postData,
      });
    if (response?.data?.success) {
      this.vehiclePosition = response?.data?.data?.vehicleposition;
    }
  }
}

export default LiveRootPathStore;
